import React from 'react';

import Loader from "../common/Loader";
import l10n from "../../l10n/localization";
import * as utils from "../../utils/utils";

export default class CargoSummary extends React.Component {
    getValues() {
        let value = 0;
        let outturnSum = 0;
        let shortageSum = 0;
        let quantity = 0;
        let shortagePercent = 0;

        for (let i = 0; i < this.props.cargoes.length; i++) {
            value += this.props.cargoes[i].value;
            outturnSum += this.props.cargoes[i].outturnTonnes;
            shortageSum += this.props.cargoes[i].quantity - this.props.cargoes[i].outturnTonnes;
            quantity += this.props.cargoes[i].quantity;
        }

        if (quantity > 0) {
            shortagePercent = shortageSum / quantity * 100;
        }

        return {
            value: value,
            outturnSum: outturnSum,
            shortageSum: shortageSum,
            quantity: quantity,
            shortagePercent: shortagePercent,
        };
    }

    render() {
        if (this.props.loading || this.props.cargoes === undefined) {
            return (<div><Loader/></div>)
        }

        let result = this.getValues();

        return (
            <div>
                <table className="cargo-summary">
                    <thead>
                    <tr>
                        <td>
                            {l10n.cargoSummary.outturn}
                        </td>
                        <td>
                            {l10n.cargoSummary.value}
                        </td>
                        <td>
                            {l10n.cargoSummary.shortage_gain}
                        </td>
                        <td>
                            {l10n.cargoSummary.shortage_percent}
                        </td>
                        <td>
                            {l10n.cargoSummary.totalQuantity}
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            {!isNaN(result.outturnSum) && result.outturnSum.toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                        <td>
                            {!isNaN(result.value) && result.value.toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                        <td>
                            {!isNaN(result.shortageSum) && result.shortageSum.toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                        <td>
                            {!isNaN(result.shortagePercent) && utils.getFlooredFixed(result.shortagePercent).toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                        <td>
                            {!isNaN(result.quantity) && result.quantity.toLocaleString('en-US').replace(/,/g, " ")}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/cargo/CargoSummary.js